import { supabase } from '../supabaseClient';
import { loadOperationalPropertyStructure } from './plotMigrationReviewService';
import { applyCanonicalPhysicalPlots, resolveOperationalPlotName } from './operationalPropertiesService';
import { listCadernoExpenses } from './cadernoExpenseService';
import { collectRealizedFieldCosts } from '../utils/fieldTaskCosts';

export async function readPerformancePages(makeQuery) {
  const rows = [];
  const pageSize = 200;
  while (true) {
    const { data, error } = await makeQuery().range(rows.length, rows.length + pageSize - 1);
    if (error) throw error;
    if (!Array.isArray(data)) throw new Error('Resposta de desempenho incompleta. Atualize a consulta.');
    rows.push(...data);
    if (data.length < pageSize) return rows;
  }
}

export async function loadPerformanceRecords(propertyId, ownerId, canReadCosts) {
  const [legacyPlots, structure] = await Promise.all([
    readPerformancePages(() => supabase.from('talhoes').select('id,nome,cultura,area,data_plantio,data_colheita')
      .eq('propriedade_id', propertyId).order('id')),
    loadOperationalPropertyStructure(),
  ]);
  const plots = applyCanonicalPhysicalPlots(legacyPlots, structure, propertyId);
  const ids = [...new Set(legacyPlots.map(plot => plot.id).concat(
    plots.flatMap(plot => plot._legacyPlotIds || [])
  ))];
  const [cycles, estimates, costsResult] = await Promise.all([
    ids.length ? readPerformancePages(() => supabase.from('ciclos_cultivo').select('*')
      .in('talhao_id', ids).neq('status', 'cancelado').order('id')) : [],
    ids.length ? readPerformancePages(() => supabase.from('produtividade_talhao').select('*')
      .in('talhao_id', ids).eq('user_id', ownerId).order('id')) : [],
    canReadCosts ? Promise.all([
      listCadernoExpenses(null, { propertyId }),
      readPerformancePages(() => supabase.from('caderno_execucoes')
        .select('id,ordem_id,propriedade_id,talhao_id,custo_real,inicio_em,status')
        .eq('propriedade_id', propertyId).eq('status', 'finalizada').not('custo_real', 'is', null).order('id')),
      ids.length ? readPerformancePages(() => supabase.from('eventos_talhao')
        .select('id,talhao_id,custo_total,data_evento').in('talhao_id', ids)
        .not('custo_total', 'is', null).order('id')) : [],
    ]).then(([expenses, executions, events]) => ({
      entries: collectRealizedFieldCosts({ expenses, executions, events }), error: null,
    }), error => ({ entries: [], error }))
      : { entries: [], error: new Error('Seu acesso não permite consultar todos os gastos do caderno desta propriedade.') },
  ]);
  const entries = costsResult.entries.map(entry => ({
    ...entry,
    plotName: resolveOperationalPlotName(plots, entry.plotId)
      || resolveOperationalPlotName(legacyPlots, entry.plotId),
  }));
  return { plots, cycles, estimates, entries, costsError: costsResult.error };
}
